module.exports = __webpack_public_path__ + "src/assets/img/cmd-go-service-w.0ed85ded.svg";